import { QueryClient } from '@tanstack/react-query'
import { ApiError, SessionExpiredError } from './api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 min — avoid redundant refetches
      gcTime: 10 * 60 * 1000, // 10 min — keep cache warm between navigations
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Session expiry is handled by the auth providers' SitzungAbgelaufenDialog (§6.59),
        // not by retrying — retrying just re-triggers the same 401 loop.
        if (error instanceof SessionExpiredError) return false
        // Don't retry 4xx errors (client faults) — only 5xx (server transient)
        if (error instanceof ApiError && error.status < 500) return false
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})
